export default __webpack_public_path__ + "static/media/user-icon.2c2f5f66.svg";